import request from '@/utils/request'

const keywordsURL = {
  List: '/article-keyword/items',
  Create: '/article-keyword/create',
  Update: '/article-keyword/update',
  Delete: '/article-keyword/delete'
}

// 关键字内链-列表
export function ListKeywords(data) {
  return request({
    url: keywordsURL.List,
    method: 'post',
    data
  })
}

// 关键字内链-新增
export function CreateKeywords(data) {
  return request({
    url: keywordsURL.Create,
    method: 'post',
    data
  })
}

// 关键字内链-编辑
export function UpdateKeywords(data) {
  return request({
    url: keywordsURL.Update,
    method: 'post',
    data
  })
}

// 关键字内链-删除
export function DeleteKeywords(data) {
  return request({
    url: keywordsURL.Delete,
    method: 'post',
    data
  })
}

export default {
  ListKeywords,
  CreateKeywords,
  UpdateKeywords,
  DeleteKeywords
}
